function TextField({ label, name, value, onChange, type = "text" }) {
  return (
    <label className="form-group">
      <span className="form-label">{label}</span>
      <input type={type} value={value || ""} onChange={(event) => onChange(name, event.target.value)} />
    </label>
  );
}

function TextAreaField({ label, name, value, onChange }) {
  return (
    <label className="form-group">
      <span className="form-label">{label}</span>
      <textarea value={value || ""} onChange={(event) => onChange(name, event.target.value)} />
    </label>
  );
}

function ToggleField({ label, name, checked, onChange }) {
  return (
    <label className="checkbox-group">
      <input type="checkbox" checked={Boolean(checked)} onChange={(event) => onChange(name, event.target.checked)} />
      <span>{label}</span>
    </label>
  );
}

function ImageField({ label, name, value, clearName, onChange, onFileChange }) {
  return (
    <div className="form-group admin-image-field">
      <span className="form-label">{label}</span>
      {value ? <img alt={label} src={value} /> : <p className="muted-text">No image uploaded.</p>}
      <input type="file" accept="image/*" onChange={(event) => onFileChange(name, event.target.files?.[0] || null)} />
      {value ? (
        <button className="btn btn-sm btn-secondary" type="button" onClick={() => onChange(clearName, true)}>
          Remove Image
        </button>
      ) : null}
    </div>
  );
}

export { ImageField, TextAreaField, TextField, ToggleField };